import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useHistory } from "react-router-dom";

type DeleteDialogProps = {
	handleModalClose: () => void;
	Mailvalidate: boolean;
};

export default function ValidateDialog({
	handleModalClose,
	Mailvalidate,
}: DeleteDialogProps) {
	const history = useHistory();

	return (
		<Dialog onClose={handleModalClose} open={!Mailvalidate} fullWidth={true}>
			<DialogTitle sx={{ fontSize: "2rem" }}>메일인증이 만료되었습니다</DialogTitle>
			<Typography style={{ padding: "1.5rem", color: "red" }}>
				메일 재인증요청 해주세요
			</Typography>
			<DialogContent>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "3rem",
					}}
				>
					<Button
						variant="outlined"
						sx={{
							color: "#747474",
							borderColor: "#CCCCCC",
							marginRight: "0.5rem",
						}}
						onClick={() => {
							history.push("/auth/login");
						}}
					>
						로그인 화면
					</Button>
					<Button
						variant="contained"
						sx={{ backgroundColor: "#2453F9", color: "white" }}
						onClick={() => {
							history.push("/auth/forgot");
						}}
					>
						메일 재전송
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
